import { Suspense, lazy, useRef, type ComponentProps } from "react"

const Screen = lazy(() =>
  import("./signing-screen").then((module) => ({
    default: module.SigningScreen,
  }))
)

/**
 * The signing screen, loaded the first time a client opens it: most visits
 * sign nothing, so the screen and its stylesheet stay out of the first load.
 * Once opened it stays mounted, so closing it returns focus to the button
 * that opened it.
 */
export function LazySigningScreen(props: ComponentProps<typeof Screen>) {
  const opened = useRef(false)
  if (props.open) opened.current = true
  if (!opened.current) return null
  return (
    <Suspense fallback={null}>
      <Screen {...props} />
    </Suspense>
  )
}
